import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import 'semantic-ui-css/semantic.min.css';
import { Header, Pagination, Select, Table } from 'semantic-ui-react';
import { titleWiseDataType } from '../../app/models/Restoration';
import { useStore } from '../../app/stores/store';
import UnauthorizedMessage from '../UnauthorizedMessage';

// interface Titlesummary {
//   title_Code: string;
//   tot_Frames: number;
//   title_Name: string;
//   fresh_YettoStart: number;
//   fresh_Pending: number;
//   qC_YettoStart: number;
//   qC_Pending: number;
//   fqA_YettoStart: number;
//   fqA_Pending: number;
//   wave_YettoStart: number;
//   wave_Pending: number;
//   cC_YettoStart: number;
//   cC_Pending: number;
//   approved_Frames: number;
// }

const TitleWiseSummary = () => {
  const { RestorationStore, commonStore } = useStore();
  const [selectedTitleCode, setSelectedTitleCode] = useState<string[]>([]);
  const [activePage, setActivePage] = useState<number>(1);
  const [totalpage, setTotalPage] = useState<number>(1);
  const [filteredData, setFilteredData] = useState<titleWiseDataType[]>([]);
  const [friendOptions, setFriendOptions] = useState<
    { key: string; text: string; value: string }[]
  >([]);
  const itemsperPage = 10;

  useEffect(() => {
    (async () => {
      RestorationStore.getTitleCode();
      const tempTotalPage = await RestorationStore.titleWiseSummaryCount();
      setTotalPage(Math.ceil(tempTotalPage / itemsperPage));
    })();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (RestorationStore.titleCodeData?.length > 0) {
      const temp = RestorationStore.titleCodeData?.map((title: string) => {
        return {
          key: title,
          text: title,
          value: title,
        };
      });
      setFriendOptions(temp);
    }
  }, [RestorationStore.titleCodeData]);

  useEffect(() => {
    RestorationStore.titleWiseReport(
      selectedTitleCode,
      activePage,
      itemsperPage,
    );
    if (selectedTitleCode?.length > 0) {
      setTotalPage(1);
    }
    // eslint-disable-next-line
  }, [selectedTitleCode, activePage]);

  useEffect(() => {
    setFilteredData(RestorationStore.titleWiseData);
  }, [RestorationStore.titleWiseData]);

  const handlePageChange = (_e: any, { activePage }: any) => {
    setActivePage(activePage);
    setFilteredData([]);
  };

  const setDD = (_e: any, data: any) => {
    if (data.value?.length > 0) {
      setSelectedTitleCode(data.value);
    } else {
      setSelectedTitleCode([]);
    }
    setFilteredData([]);
  };

  return (
    <>
      {RestorationStore.loading &&
      commonStore.filterModeOne.length > 0 &&
      !commonStore.filterModeOne?.includes('RSTSR01') ? (
        <UnauthorizedMessage />
      ) : (
        <div className="title-wise-table">
          <Header>Title Summary Report</Header>
          <div className="tr-dropdown">
            <label>Title Code:</label>
            <Select
              placeholder="Select Title code"
              filter
              Selection
              search
              clearable
              options={friendOptions}
              value={selectedTitleCode}
              onChange={(_event, data) => setDD(_event, data)}
              multiple
            />
          </div>
          <div>
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell colSpan={3}>
                    Project Details
                  </Table.HeaderCell>
                  <Table.HeaderCell colSpan={3}>
                    Fresh Restoration
                  </Table.HeaderCell>
                  <Table.HeaderCell colSpan={3}>Quality Check</Table.HeaderCell>
                  <Table.HeaderCell colSpan={3}>
                    Final Quality Analysis
                  </Table.HeaderCell>
                   <Table.HeaderCell colSpan={3}>
                    Client Quality Correction
                  </Table.HeaderCell>
                  <Table.HeaderCell colSpan={3}>
                    Wave Production
                  </Table.HeaderCell>
                  <Table.HeaderCell colSpan={3}>
                    CC Form Production
                  </Table.HeaderCell>
                  <Table.HeaderCell colSpan={2}>Approved</Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                  <Table.HeaderCell>Title Code</Table.HeaderCell>
                  <Table.HeaderCell>Total Frames</Table.HeaderCell>
                  <Table.HeaderCell>Title Name</Table.HeaderCell>
                  <Table.HeaderCell>Fresh Yet to Start</Table.HeaderCell>
                  <Table.HeaderCell>Fresh Pending</Table.HeaderCell>
                  <Table.HeaderCell>%</Table.HeaderCell>
                  <Table.HeaderCell>QC Yet to Start</Table.HeaderCell>
                  <Table.HeaderCell>QC Pending</Table.HeaderCell>
                  <Table.HeaderCell>%</Table.HeaderCell>
                  <Table.HeaderCell>FQA Yet to Start</Table.HeaderCell>
                  <Table.HeaderCell>FQA Pending</Table.HeaderCell>
                  <Table.HeaderCell>%</Table.HeaderCell>
                  <Table.HeaderCell>CQC Yet to Start</Table.HeaderCell>
                  <Table.HeaderCell>CQC Pending</Table.HeaderCell>
                  <Table.HeaderCell>%</Table.HeaderCell>
                  <Table.HeaderCell>Wave Yet to Start</Table.HeaderCell>
                  <Table.HeaderCell>Wave Pending</Table.HeaderCell>
                  <Table.HeaderCell>%</Table.HeaderCell>
                  <Table.HeaderCell>CC Yet to Start</Table.HeaderCell>
                  <Table.HeaderCell>CC Pending</Table.HeaderCell>
                  <Table.HeaderCell>%</Table.HeaderCell>
                  <Table.HeaderCell>Total Approved Frame</Table.HeaderCell>
                  <Table.HeaderCell>Complete %</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {RestorationStore.loading && (
                  <Table.Row>
                    <Table.Cell colSpan={20} textAlign="center">
                      Loading...
                    </Table.Cell>
                  </Table.Row>
                )}
                {!RestorationStore.loading && filteredData?.length === 0 && (
                  <Table.Row>
                    <Table.Cell colSpan={20} textAlign="center">
                      Data is currently unavailable
                    </Table.Cell>
                  </Table.Row>
                )}
                {filteredData?.map((items, index) => (
                  <Table.Row key={index}>
                    <Table.Cell>{items.title_Code}</Table.Cell>
                    <Table.Cell>{items.tot_Frames}</Table.Cell>
                    <Table.Cell>{items.title_Name}</Table.Cell>
                    <Table.Cell>{items.fresh_YettoStart}</Table.Cell>
                    <Table.Cell>{items.fresh_Pending}</Table.Cell>
                    <Table.Cell>
                      {items.fresh_YettoStart + items.fresh_Pending === 0
                        ? '0'
                        : Math.round(
                            ((items.fresh_YettoStart + items.fresh_Pending) /
                              items.tot_Frames) *
                              100,
                          )}
                      %
                    </Table.Cell>
                    <Table.Cell>{items.qC_YettoStart}</Table.Cell>
                    <Table.Cell>{items.qC_Pending}</Table.Cell>
                    <Table.Cell>
                      {items.qC_YettoStart + items.qC_Pending === 0
                        ? '0'
                        : Math.round(
                            ((items.qC_YettoStart + items.qC_Pending) /
                              items.tot_Frames) *
                              100,
                          )}
                      %
                    </Table.Cell>
                    <Table.Cell>{items.fqA_YettoStart}</Table.Cell>
                    <Table.Cell>{items.fqA_Pending}</Table.Cell>
                    <Table.Cell>
                      {items.fqA_YettoStart + items.fqA_Pending === 0
                        ? '0'
                        : Math.round(
                            ((items.fqA_YettoStart + items.fqA_Pending) /
                              items.tot_Frames) *
                              100,
                          )}
                      %
                    </Table.Cell>
                    <Table.Cell>{items.cqC_YettoStart}</Table.Cell>
                    <Table.Cell>{items.cqC_Pending}</Table.Cell>
                    <Table.Cell>
                      {items.cqC_YettoStart + items.cqC_Pending === 0
                        ? '0'
                        : Math.round(
                            ((items.cqC_YettoStart + items.cqC_Pending) /
                              items.tot_Frames) *
                              100,
                          )}
                      %
                    </Table.Cell>
                    <Table.Cell>{items.wave_YettoStart}</Table.Cell>
                    <Table.Cell>{items.wave_Pending}</Table.Cell>
                    <Table.Cell>
                      {items.wave_YettoStart + items.wave_Pending === 0
                        ? '0'
                        : Math.round(
                            ((items.wave_YettoStart + items.wave_Pending) /
                              items.tot_Frames) *
                              100,
                          )}
                      %
                    </Table.Cell>
                    <Table.Cell>{items.cC_YettoStart}</Table.Cell>
                    <Table.Cell>{items.cC_Pending}</Table.Cell>
                    <Table.Cell>
                      {items.cC_YettoStart + items.cC_Pending === 0
                        ? '0'
                        : Math.round(
                            ((items.cC_YettoStart + items.cC_Pending) /
                              items.tot_Frames) *
                              100,
                          )}
                      %
                    </Table.Cell>
                    <Table.Cell>{items.approved_Frames}</Table.Cell>
                    <Table.Cell>
                      {items.approved_Frames === 0
                        ? '0'
                        : Math.round(
                            (items.approved_Frames / items.tot_Frames) * 100,
                          )}
                      %
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
            {totalpage === 1 ? (
              <></>
            ) : (
              <Pagination
                activePage={activePage}
                totalPages={totalpage}
                onPageChange={handlePageChange}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default observer(TitleWiseSummary);
